import type { FC } from 'react';
import React from 'react';
import {
  Box,
  Body,
  Col,
  Flex,
  Glyph,
} from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import { TransportType } from '@/generated/graphql';
import type { SectionFragment } from '@/generated/graphql';

interface CarrierChangeMapItineraryProps {
  transportType: SectionFragment['transportType'];
}

const CarrierChangeMapItinerary: FC<CarrierChangeMapItineraryProps> = ({
  transportType,
}) => {
  const { t } = useTranslation();

  return (
    <Box mb="1x_small">
      <Flex flexDirection="row">
        <Col>
          {transportType === TransportType.Plane ? (
            <Glyph
              size="small"
              color="neutral.80"
              category="Planes"
              name="FlightRight"
            />
          ) : (
            <Glyph
              size="small"
              color="neutral.80"
              category="TravelProducts"
              name="Train"
            />
          )}
        </Col>
        <Col>
          <Box pl="1x_small">
            <Body type="xSmall" color="neutral.80">
              {transportType === TransportType.Plane
                ? t('flightSummary.itinerary.stop.airlineChange')
                : t('flightSummary.itinerary.stop.trainChange')}
            </Body>
          </Box>
        </Col>
      </Flex>
    </Box>
  );
};

export default CarrierChangeMapItinerary;
